// extracted by mini-css-extract-plugin
module.exports = {"content":"Modal_ketogo_content__HA2co","buttons":"Modal_ketogo_buttons__3Yx0Z"};